/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import '../../common/flexible_transfer/flexible_transfer_request_response';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "dashboard": {
            "nested": {
              "flexible_transfer": {
                "nested": {
                  "DashboardWebFlexibleTransferService": {
                    "methods": {
                      "FlexibleTransfer": {
                        "requestType": ".squareup.bbfrontend.common.flexible_transfer.FlexibleTransferRequest",
                        "responseType": ".squareup.bbfrontend.common.flexible_transfer.FlexibleTransferResponse"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.flexible_transfer?.nested?.DashboardWebFlexibleTransferService) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE DashboardWebFlexibleTransferService @ squareup/bbfrontend/dashboardweb/flexible_transfer/flexible_transfer_service.proto at 13:1
 */
export const DashboardWebFlexibleTransferService = $root.lookupService('squareup.bbfrontend.dashboard.flexible_transfer.DashboardWebFlexibleTransferService');